/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaPendingTag from 'DesignSystem/TysiaPendingTag/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/SubmitAction"
  
}) {
let tabSchedulingSlotIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling.slot_id',
})
let overlayAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'overlay',
path: 'appointment_id',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="SubmitAction.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 width="100%"
 type="primary"
 disabled={tabSchedulingSlotIdValueData ? false : true}
 data="tab.scheduling.slot_id"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={overlayAppointmentIdValueData ? "Save changes" : "Schedule appointment"}
 data="overlay.appointment_id"
/>
)}
</TysiaButton>
<div
  data-testid="SubmitAction.Vertical"
  data-view-path={viewPath}
 style={{'--r-1-17BQDi': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaPendingTag
  viewPath={`${viewPath}/TysiaPendingTag`}
 fill2={dtColorsWhite}
 placement="top-end"
/>
</div>
</div>
{children}
</React.Fragment>)
}